exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.bleh[data-v-37dfd6fc] {\n  background-color: #0a43a7;\n}\n.logo[data-v-37dfd6fc] {\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  width: 40%;\n  margin-top: 35%;\n}\n", ""]);

